import { listPinTemplate } from "./listPin";
import { venueFeatureTemplate } from "./venueFeature";
import { venueOverlayTemplate } from "./venueOverlay";
import { venueCenteredTemplate } from "./venueCentered";
import { venueCardTemplate } from "./venueCard";
import { boardCoverTemplate } from "./boardCover";
import { venueBoldTemplate } from "./venueBold";
import { venueCompareTemplate } from "./venueCompare";
import { venueFramedTemplate } from "./venueFramed";
import { venueScriptTemplate } from "./venueScript";
import { venueCollageTemplate } from "./venueCollage";
import { venueListTemplate } from "./venueList";
import { venueListCollageTemplate } from "./venueListCollage";
import { venueChecklistTemplate } from "./venueChecklist";
import { venueCostTemplate } from "./venueCost";
import { venueTrendTemplate } from "./venueTrend";
import { carouselTemplate } from "./carousel";
import { Template, TemplateName } from "./types";

export const templates: Record<TemplateName, Template> = {
  listPin: listPinTemplate,
  venueFeature: venueFeatureTemplate,
  venueOverlay: venueOverlayTemplate,
  venueCentered: venueCenteredTemplate,
  venueCard: venueCardTemplate,
  boardCover: boardCoverTemplate,
  venueBold: venueBoldTemplate,
  venueCompare: venueCompareTemplate,
  venueFramed: venueFramedTemplate,
  venueScript: venueScriptTemplate,
  venueCollage: venueCollageTemplate,
  venueList: venueListTemplate,
  venueListCollage: venueListCollageTemplate,
  venueChecklist: venueChecklistTemplate,
  venueCost: venueCostTemplate,
  venueTrend: venueTrendTemplate,
  carousel: carouselTemplate,
};

export * from "./palettes";
export * from "./typography";
export * from "./types";
